export default "__VITE_ASSET__D_ajiDl5__"